import React, { useRef, useState, useEffect, useMemo } from 'react';
import { Table, Thead, Tbody, Tr, Th, Td, chakra, Box, Text, Button, Flex, useToast, Input, HStack, Tooltip, Icon, IconButton, Spacer, Spinner } from '@chakra-ui/react'
import { Modal, ModalOverlay, ModalContent } from '@chakra-ui/react'
import { Menu, MenuButton, MenuList, MenuItem, MenuItemOption, MenuGroup, MenuOptionGroup, MenuDivider, } from '@chakra-ui/react'
import { NumberInput, NumberInputField, NumberInputStepper, NumberIncrementStepper, NumberDecrementStepper } from '@chakra-ui/react'
import { Slider, SliderTrack, SliderFilledTrack, SliderThumb, SliderMark } from '@chakra-ui/react'
import { useTable, useSortBy } from 'react-table'
import { useNavigate, useSearchParams } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { FaRegCalendarTimes, FaAngleDown, FaAngleLeft, FaAngleRight, FaAngleDoubleLeft, FaAngleDoubleRight } from 'react-icons/fa';
import DatePicker from 'react-date-picker';
import '../../css/DatePicker.css';
import '../../css/Calendar.css';
import '../../css/App.css'

import TableHead from '../../GlobalComponents/TableHead';
import WebsiteHeader from '../../GlobalComponents/WebsiteHeader';
import HistoryBox from '../HistoryBox';
import { ErrorToast, WarnToast, CheckToast } from '../../GlobalComponents/CustomToast';
import ConfirmModal from '../../GlobalComponents/ConfirnModal';
import BaseModal from '../../GlobalComponents/BaseModal';
import ImageBox from '../ImageBox';

export default function MultiPaketSuche(props) {

    const [tableData, setTableData] = useState([]);
    const [CurentIndex, setCurentIndex] = useState(null);
    const [KundenIndex, setKundenIndex] = useState(null);
    const [history, setHistory] = useState([]);
    const [historyOpen, setHistoryOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const [ImageOpen, setImageOpen] = useState(false);
    const [ImageUri, setImageUri] = useState([]);
    const [ImageDir, setImageDir] = useState('');
    const [ImageRecipient, setImageRecipient] = useState('');

    const [ConfirmOpen, setConfirmOpen] = useState(false);
    const [SearchType, setSearchType] = useState('all');

    const [Date1, setDate1] = useState(new Date());
    const [Date2, setDate2] = useState(new Date());

    const navigate = useNavigate(); //navigate to a certain path
    const [searchParams, setSearchParams] = useSearchParams(); //read and set query-params
    const toast = useToast();
    const toastIdRef = React.useRef();

    const [SearchValue, setSearchValue] = useState('');
    const [SearchRepeat, setSearchRepeat] = useState(2);
    const [SearchManif, setSearchManif] = useState('');

    //pagination state
    const [page, setPage] = useState(0);
    const [sliderValue, setSliderValue] = React.useState(1)
    const [showTooltip, setShowTooltip] = React.useState(false)
    const pageSize = 25;
    const start = page * pageSize;
    const end = start + pageSize;
    const currentPageData = tableData.slice(start, end);
    const totalPages = Math.ceil(tableData.length / pageSize);
    const handlePrev = () => updatePage(Math.max(0, page - 1));
    const handleNext = () => updatePage(Math.min(totalPages - 1, page + 1));
    const updatePage = (p) => { setSliderValue(p + 1); setPage(p) }

    useEffect(() => {

        _getAdressParams();
        //_getsetPrevDay();

        window.addEventListener('keydown', handleKeyInput);

        return () => {
            window.removeEventListener('keydown', handleKeyInput);
        };
    }, []);

    async function _getAdressParams() {

        var start = searchParams.get('start');
        var end = searchParams.get('end');
        var type = searchParams.get('type');
        var search = searchParams.get('search');

        const startDate = new Date(start);
        const endDate = new Date(end);

        if (isNaN(startDate.getTime()) || isNaN(endDate.getTime()) || type === null || type === undefined) {
            _getsetPrevDay();
            return;
        };

        setDate1(startDate)
        setDate2(endDate)

        switch (type) {
            case 'unfinished':
                setSearchType('unfinished')
                _fetchUnfinished(start, end)
                break;
            case 'repeat':
                if (search !== null && search !== '') {
                    setSearchType('repeat')
                    setSearchValue(search)
                    _fetchStuckPakete(search, start, end)
                }
                break;
            case 'manif':
                if (search !== null && search !== '') {
                    setSearchType('manif')
                    setSearchManif(search)
                    _fetchManifPakete(search, start, end);
                }
                break;
            default:
                if (search !== null && search.length >= 3) {
                    setSearchType('all')
                    setSearchValue(search)
                    _fetchPakete(search, start, end)
                }
                break;
        }
    }
    const FindPaketHandler = () => {

        if (!Date1 || !Date2) {
            toast({ render: () => (<WarnToast title='Datum Fehlerhaft' descr="Von/Bis Datumsangaben sind fehlerhaft!" />), status: 'warn', duration: 5000, isClosable: true, position: 'top', })
            return false
        };
        var start = Date1.getFullYear() + '-' + (Date1.getMonth() + 1) + '-' + Date1.getDate()
        var end = Date2.getFullYear() + '-' + (Date2.getMonth() + 1) + '-' + Date2.getDate()

        switch (SearchType) {
            case 'repeat':
                _fetchStuckPakete(SearchRepeat, start, end);
                break;
            case 'manif':
                _fetchManifPakete(SearchManif, start, end);
                break;
            case 'unfinished':
                _fetchUnfinished(start, end);
                break;
            default:
                _fetchPakete(SearchValue, start, end);
                break;
        }
    }

    const columns = useMemo(() => {
        switch (SearchType) {
            case 'repeat':
                return [
                    { label: 'Paketnummer', accessor: 'Paketnummer', sortable: true, width: 40 },
                    { label: 'Lieferschein', accessor: 'Lieferschein', sortable: true, width: 40 },

                    { label: 'Manifest', accessor: 'Manifest', sortable: true, width: 30 },
                    { label: 'Tour', accessor: 'Tour', sortable: true, width: 60 },
                    { label: 'Fahrer', accessor: 'User_Name', sortable: true, width: 60 },

                    { label: 'Kennzeichen', accessor: 'Kennzeichen', sortable: true, width: 60 },
                    { label: 'Status', accessor: 'Status', sortable: true, width: 30 },
                    { label: 'Zustell_Status', accessor: 'Zustell_Status', sortable: true, width: 60 },
                    { label: 'Änderungsdatum', accessor: 'Änderungsdatum', sortable: true, width: 60 },
                    { label: 'Wiederholungen', accessor: 'Wiederholung', sortable: true, width: 10 }
                ];
            case 'unfinished':
                return [
                    { label: 'Paketnummer', accessor: 'Paketnummer', sortable: true, width: 40 },
                    { label: 'Lieferschein', accessor: 'Lieferschein', sortable: true, width: 40 },

                    { label: 'Manifest', accessor: 'Manifest', sortable: true, width: 30 },
                    { label: 'Tour', accessor: 'Tour', sortable: true, width: 60 },
                    { label: 'Fahrer', accessor: 'Fahrer', sortable: true, width: 60 },

                    { label: 'Kennzeichen', accessor: 'Kennzeichen', sortable: true, width: 60 },
                    { label: 'Status', accessor: 'Status', sortable: true, width: 30 },
                    { label: 'Extra Status', accessor: 'Zustell_Status', sortable: true, width: 60 },
                    { label: 'Letzte Änderung', accessor: 'Statuszeit', sortable: true, width: 60 },
                    { label: 'Wiederholungen', accessor: 'Wiederholt', sortable: true, width: 10 }
                ];
            case 'manif':
                return [
                    { label: 'Paketnummer', accessor: 'Paketnummer', sortable: true, width: 40 },
                    { label: 'Lieferschein', accessor: 'Lieferschein', sortable: true, width: 40 },

                    { label: 'Manifest', accessor: 'Manifest', sortable: true, width: 30 },
                    { label: 'Tour', accessor: 'Tour', sortable: true, width: 60 },
                    { label: 'Fahrer', accessor: 'User_Name', sortable: true, width: 60 },

                    { label: 'Kennzeichen', accessor: 'Kennzeichen', sortable: true, width: 60 },
                    { label: 'Status', accessor: 'Status', sortable: true, width: 30 },
                    { label: 'Zustell_Status', accessor: 'Zustell_Status', sortable: true, width: 60 },
                    { label: 'War in', accessor: 'WasInManifest', sortable: true, width: 30 },
                    { label: 'Zuletzt', accessor: 'Änderungsdatum', sortable: true, width: 60 },
                ];
            default:
                return [
                    { label: 'Paketnummer', accessor: 'Paketnummer', sortable: true, width: 40 },
                    { label: 'Lieferschein', accessor: 'Lieferschein', sortable: true, width: 40 },

                    { label: 'Manifest', accessor: 'Manifest', sortable: true, width: 30 },
                    { label: 'Tour', accessor: 'Tour', sortable: true, width: 60 },
                    { label: 'Fahrer', accessor: 'User_Name', sortable: true, width: 60 },

                    { label: 'Kennzeichen', accessor: 'Kennzeichen', sortable: true, width: 60 },
                    { label: 'Status', accessor: 'Status', sortable: true, width: 30 },
                    { label: 'Zustell_Status', accessor: 'Zustell_Status', sortable: true, width: 60 },
                    { label: 'Recipient', accessor: 'Recipient', sortable: true, width: 60 },
                ]
        }
    }, [SearchType])

    async function _getsetPrevDay() {

        var date = new Date()
        const day = date.getDay();
        const daysToSubtract = day === 0 ? 2 : day === 1 ? 3 : 1;
        const previousWorkday = new Date(date);
        previousWorkday.setDate(date.getDate() - daysToSubtract);
        setDate1(previousWorkday);
        setDate2(date);
    }
    const handleSorting = (sortField, sortOrder) => {
        if (sortField) {
            const sorted = [...tableData].sort((a, b) => {
                if (a[sortField] == null && b[sortField] == null) return 0;
                if (a[sortField] == null) return 1;
                if (b[sortField] == null) return -1;
                return (
                    a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
                        numeric: true,
                    }) * (sortOrder === "asc" ? 1 : -1)
                );
            });
            setTableData(sorted);
        }
    };
    async function APIConnector(target, params, json = {}) {

        var url = props.server + '/API/index.php/' + target + params;
        const cookies = new Cookies();
        var UserToken = cookies.get('LoginToken');
        json.Token = UserToken;
        try {
            const response = await fetch(url, {
                method: 'POST',
                //headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': 'Basic VHJhdmVsZXI6VGhpczEhSXMyIlRoZTPCp1Bhc3N3b3JkNCQ=' },
                body: JSON.stringify(json)
            });
            const results = await response.json();
            if (results.AuthKey === 'invalid') {
                props.searchCall('logOut')
            } else if (results.AuthKey === 'noRight') {
                toast({ render: () => (<WarnToast title='Berechtigungen Fehlerhaft' descr='Sie besitzen keine Berechtigung für diese Aktion!' />), status: 'error', duration: 7000, isClosable: true, position: 'top', })
                props.searchCall('newRights', results.Rights)
            } else return results
        } catch (error) { console.log(error) }
    }
    async function _fetchPakete(text = "", start = "", end = "") {

        if (text.length < 3) {
            toast({ render: () => (<WarnToast title='Eingabe zu kurz!' descr='Bitte geben Sie mindestens 3 Zeichen an' />), status: 'warning', duration: 2300, isClosable: true, position: 'top' })
            return false
        }
        setLoading(true);

        var search = text;
        var params = '?start=' + start + '&end=' + end + '&search=' + search

        var data = await APIConnector('Web_SearchPaket', params, {})
        if (Array.isArray(data)) {
            setTableData(data);
            setCurentIndex(null);
            setPage(0);
        } else toast({ render: () => (<ErrorToast title='Abruf fehlgeschlagen!' description="Die Serverantwort war fehlerhaft!" />), status: 'error', duration: 5000, isClosable: true, position: 'top', })
        setLoading(false);
    }
    async function _fetchStuckPakete(times, start = "", end = "") {

        if (!parseInt(times)) { times = 0; }

        setLoading(true);
        var params = '?start=' + start + '&end=' + end + '&times=' + times
        var data = await APIConnector('Web_SearchStuckPaket', params, {})
        //console.log(data);
        if (Array.isArray(data)) {
            setTableData(data);
            setCurentIndex(null);
            setPage(0);
        } else toast({ render: () => (<ErrorToast title='Abruf fehlgeschlagen!' description="Die Serverantwort war fehlerhaft!" />), status: 'error', duration: 5000, isClosable: true, position: 'top', })
        setLoading(false);
    }
    async function _fetchManifPakete(manifest = '', start = "", end = "") {

        setLoading(true);
        var start = Date1.getFullYear() + '-' + (Date1.getMonth() + 1) + '-' + Date1.getDate()
        var end = Date2.getFullYear() + '-' + (Date2.getMonth() + 1) + '-' + Date2.getDate()

        var params = '?start=' + start + '&end=' + end + '&manifest=' + manifest

        var data = await APIConnector('FindPaketPastManifest', params, {})

        if (Array.isArray(data)) {
            setTableData(data);
            setCurentIndex(null);
            setPage(0);
        } else toast({ render: () => (<ErrorToast title='Abruf fehlgeschlagen!' description="Die Serverantwort war fehlerhaft!" />), status: 'error', duration: 5000, isClosable: true, position: 'top', })
        setLoading(false);
    }
    async function _fetchUnfinished(start = '', end = '') {

        setLoading(true);
        var params = '?start=' + start + '&end=' + end

        var data = await APIConnector('SearchUnresolvedPakete', params, {})
        if (Array.isArray(data)) {
            setTableData(data);
            setCurentIndex(null);
            setPage(0);
        } else toast({ render: () => (<ErrorToast title='Abruf fehlgeschlagen!' description="Die Serverantwort war fehlerhaft!" />), status: 'error', duration: 5000, isClosable: true, position: 'top', })
        setLoading(false);
    }
    async function _fetchHistory(PaketNr) {

        var params = '?PaketNr=' + PaketNr;

        var data = await APIConnector('GET_PaketHistory', params, {})
        if (Array.isArray(data)) {
            setHistory(data);
        } else toast({ render: () => (<ErrorToast title='Abruf fehlgeschlagen!' descr="Die Serverantwort war fehlerhaft!" />), status: 'error', duration: 5000, isClosable: true, position: 'top', })
    }
    async function _requestDeletePaket(PaketNr, Manifest) {

        var body = { PaketNr, Manifest }
        var data = await APIConnector('Web_PaketDelete', '', body)
        if (data === 'success') {
            return true;
        } else {
            toast({ render: () => (<ErrorToast title='Paketlöschung abgebrochen!' descr="Dieses Paket kann nicht gelöscht werden!" />), status: 'error', duration: 5000, isClosable: true, position: 'top', })
            setConfirmOpen(false);
        }
    }
    async function deletePaketHandler() {

        if (CurentIndex !== null) {

            var PaketNr = tableData[CurentIndex].Paketnummer;
            var Manifest = tableData[CurentIndex].Manifest;

            var result = await _requestDeletePaket(PaketNr, Manifest);

            if (result) {
                var PaketData = [...tableData];
                PaketData.splice(CurentIndex, 1);
                setTableData(PaketData);
                setConfirmOpen(false);
                setCurentIndex(null);
                if (PaketData.length / pageSize >= page + 1) { setPage(0) }

            } else {
                //error                
            }
        }
    }
    const handleKeyInput = (event) => { //-- not fully implemented

        switch (event.key) {
            case 'h':
                selectHistory();
                break;
            case 'k':
                selectKundenData();
                break;

            default:
                break;
        }
    };
    const handleImage = (e, item) => { //open/close Image for Recipient

        e.stopPropagation();

        console.log(item)
        console.log(item.ImageUri)

        if (item.ImageUri !== null) {

            if (true //item.LieferZeit > '2024-09-20 12:00:00'

            ) {
                setImageDir('tour_images/' + item.Manifest + '/'// + item.LieferID + '/' 
                );
            } else {
                setImageDir('tmp/');
            }
            setImageUri(JSON.parse(item.ImageUri))
            setImageRecipient(item.Recipient);
            setImageOpen(true)
        }
    }
    function ImageCall() {
        setImageOpen(false)
    }
    async function selectHistory() {
        //console.log(CurentIndex)
        if (CurentIndex !== null && !historyOpen) {
            await _fetchHistory(tableData[CurentIndex].Paketnummer);
            //setHistoryImage(Image)
            setHistoryOpen(true)
        }
    }
    async function selectKundenData() {
        //console.log(CurentIndex)
        if (CurentIndex !== null && KundenIndex == null) {
            setKundenIndex(CurentIndex);
        }
    }
    async function openManifestPaket() {

        if (CurentIndex !== null) {
            searchParams.set('manifest', tableData[CurentIndex].Manifest);
            searchParams.set('ablade', tableData[CurentIndex].AbladeID);
            searchParams.set('liefer', tableData[CurentIndex].LieferID);
            searchParams.set('paket', tableData[CurentIndex].Paketnummer);
            //navigate(`/manifeste/view?${searchParams.toString()}`);
            window.open(`${window.location.origin}/manifeste/view?${searchParams.toString()}`, '_blank')
        }
    }
    async function openAbladeMove() {

        if (CurentIndex !== null) {
            searchParams.set('manifest', tableData[CurentIndex].Manifest);
            searchParams.set('ablade', tableData[CurentIndex].AbladeID);
            //navigate(`/manifeste/edit/transfer?${searchParams.toString()}`);
            window.open(`${window.location.origin}/manifeste/edit/transfer?${searchParams.toString()}`, '_blank')
        }
    }
    const HistoryCall = () => {

        setHistoryOpen(false)
    }
    function handleSelect(index) {

        var idx = page * pageSize + index

        if (CurentIndex !== idx) {
            setCurentIndex(idx);
        } else {
            setCurentIndex(null);
        }
    }
    const colorMaker = (Status) => {

      console.log(Status)

      switch (Status) {
        case 'Fertig':
          return '#b8edc6'
        case 'Schaden':
        case 'Behalten':
        case 'Zurück':
          return '#fcb1b1'
        case 'in Zustellung': 
        case 'auf Fahrzeug':
          return '#fdd386'
        default:
          return 'fff'
      }
    }

    const SearchTypeInput = useMemo(() => {
        switch (SearchType) {
            case 'repeat':
                return (
                    <Flex alignItems='center' justifyContent='space-between'>
                        <Text fontSize={18} marginLeft={1} >ab</Text>
                        <NumberInput size='sm' min={0} max={999} allowMouseWheel marginX={1} borderWidth={0} onChange={(value) => setSearchRepeat(value)} defaultValue={SearchRepeat}>
                            <NumberInputField fontSize={18} paddingLeft={0} paddingRight={19} textAlign='center' />
                            <NumberInputStepper>
                                <NumberIncrementStepper />
                                <NumberDecrementStepper />
                            </NumberInputStepper>
                        </NumberInput>
                        <Text fontSize={16} >Wiederholungen</Text>
                    </Flex>
                )
            case 'manif':
                return (
                    <Flex alignItems='center' justifyContent='space-between'>
                        <Text fontSize={18} marginLeft={1} >war in Manifest: </Text>
                        <Input flex={1} h='35px' borderRadius={0} borderWidth={0} fontSize={17} bg='#fff' placeholder='000000' padding={0} marginLeft={2} textAlign='center'
                            onChange={(event) => setSearchManif(event.target?.value)} defaultValue={SearchManif} />
                    </Flex>
                )
            case 'unfinished':
                return (
                    <Flex flex={1} alignItems='center' justifyContent='center'>
                        <Text fontSize={18} marginLeft={1} >Unfertige Pakete</Text>
                    </Flex>
                )
            default:
                return (
                    <Input flex={1} h='35px' borderRadius={0} borderWidth={0} fontSize={17} bg='#fff' placeholder='Suchtext...' onChange={(event) => setSearchValue(event.target?.value)} defaultValue={SearchValue} />
                )
        }
    }, [SearchType])

    return (
        <Flex flexDirection='column' height='100vh'>
            <WebsiteHeader Text='TourPortal / Paket Suche' onClick={() => props.searchCall('back')} server={props.server} User={props.ActiveUser} />

            <Flex flex={1} backgroundColor='#ccc' p={1} flexDirection='column' overflow='auto' minHeight="400px" minWidth="750px">

                <Flex bg='#fff' alignItems='center' justifyContent='flex-start' flexWrap='wrap'
                    mb={1} borderWidth={1} borderColor='#000' borderRadius={3} py={1} >

                    <Flex my={1} mx={3} width='770px' minHeight='40px' border='0px solid black' alignItems='center' justifyContent='space-evenly' borderRadius={6} bg='#1DA1F2' flexWrap='wrap'>
                        <IconButton bg='#1DA1F2' color='#fff' width='40px'
                            icon={<Icon as={FaRegCalendarTimes} color='#fff' boxSize={25} />} onClick={() => _getsetPrevDay()}
                            borderRadius='5px 0px 0px 5px' />
                        <Text color='#fff' fontWeight='semibold' fontSize={17} mx={1} >von:</Text>
                        <DatePicker onChange={setDate1} value={Date1} format='dd.MM.y' border='0px solid black' />
                        <Text color='#fff' fontWeight='semibold' fontSize={17} mx={1} >bis:</Text>
                        <DatePicker onChange={setDate2} value={Date2} format='dd.MM.y' border='0px solid black' />

                        <Flex minWidth='26%' flex={1} h='35px' border='0px solid #1DA1F2' borderRadius={0} bg='#fff' mx={1} ml={2} alignItems='center' justifyContent='space-between'>

                            {SearchTypeInput}

                            <Menu placement='bottom-end' autoSelect={false}>
                                <MenuButton as={Button} height='30px' width='30px' margin='0px' bgColor='#fff' alignItems='center' justifyContent='center' padding={0} paddingTop={1} mx={1}>
                                    <Icon as={FaAngleDown} color='##3b3b3b' boxSize='20px' />
                                </MenuButton>
                                <MenuList zIndex={2}>

                                    <Tooltip hasArrow bg='#1DA1F2' color='#fff' placement='left' label={'Suche in verschiedenen Feldern nach Textzeichen'}>
                                        <MenuItem onClick={() => setSearchType('all')}>Zeichen Suche</MenuItem>
                                    </Tooltip>
                                    <Tooltip hasArrow bg='#1DA1F2' color='#fff' placement='left' label={'Suche alle Pakete aus dem Zeitraum, die X-mal verschoben wurden'}>
                                        <MenuItem onClick={() => setSearchType('repeat')}>Wiederholungen</MenuItem>
                                    </Tooltip>
                                    <Tooltip hasArrow bg='#1DA1F2' color='#fff' placement='left' label={'Suche alle unfertigen Pakete, die während des Zeitraums verschoben wurden'}>
                                        <MenuItem onClick={() => setSearchType('unfinished')}>Unfertige Pakete</MenuItem>
                                    </Tooltip>
                                    <Tooltip hasArrow bg='#1DA1F2' color='#fff' placement='left' label={'Suche alle Pakete, die sich einmal in einer bestimmten Tour befanden'}>
                                        <MenuItem onClick={() => setSearchType('manif')}>war in Manifest</MenuItem>
                                    </Tooltip>

                                </MenuList>
                            </Menu>

                        </Flex>
                        <Button onClick={(e) => [e.stopPropagation(), FindPaketHandler()]} bg='#1DA1F2' color='#fff' borderRadius='0px 5px 5px 0px'>Suche</Button>
                    </Flex>

                    <HStack spacing={0.5} my={1} mx={3}>
                        <Button bg='#1DA1F2' color='#fff' borderRadius={'5px 0px 0px 5px'} onClick={() => selectKundenData()} isDisabled={CurentIndex === null}>KundenDaten</Button>
                        <Button bg='#1DA1F2' color='#fff' borderRadius={'0px 5px 5px 0px'} onClick={() => selectHistory()} isDisabled={CurentIndex === null}>Pakethistorie</Button>
                    </HStack>
                    <HStack spacing={0.5} my={1} mx={3}>
                        <Tooltip label="Paket in der Tour ansehen" placement='top' hasArrow bg='#666'>

                            <Button colorScheme='green' borderRadius={'5px 0px 0px 5px'} onClick={() => openManifestPaket()} isDisabled={CurentIndex === null}>gehe zu Manifest</Button>
                        </Tooltip>
                        <Tooltip label="Die zugehörige Abladestelle Verschieben" placement='top' hasArrow bg='#666'>

                            <Button colorScheme='green' borderRadius={'0px 5px 5px 0px'} onClick={() => openAbladeMove()} isDisabled={CurentIndex === null  || tableData[CurentIndex].Object_Status !== 'Active'}
                            >gehe zu Verschieben</Button>
                        </Tooltip>
                    </HStack>
                    <Box my={1} mx={3} >
                        <Button colorScheme='orange' borderRadius={'5px'} onClick={() => setConfirmOpen(true)} isDisabled={CurentIndex === null || tableData[CurentIndex].Object_Status !== 'Active'}
                        >Paket Löschen</Button>
                    </Box>
                </Flex>
                <Flex flex={1} bg='#fff' flexDirection='column' alignItems='center' justifyContent='center' borderWidth={1} borderColor='#000' borderRadius={3} padding={2} overflow='auto' >

                    {tableData.length > 0 ? (
                        <>
                            <Table size="small"  colorScheme='blackAlpha' width='80%' >
                                <TableHead {...{ columns, handleSorting }} />
                                <Tbody>
                                    {currentPageData.map((row, index) => {
                                        return (
                                            <Tr key={row.Paketnummer} onClick={() => handleSelect(index)}
                                                bg={row.Object_Status === 'Active' ? colorMaker(row.Status) : '#bbb'}
                                                color={row.Object_Status === 'Active' ? null : '#fff' }
                                                border={CurentIndex === index + (page * pageSize) ? '3px dashed #3794ff' : null}
                                                fontSize={17}
                                            >
                                                {columns.map(({ accessor }) => {
                                                    const tData = row[accessor];
                                                    return (<React.Fragment key={accessor}>
                                                        <Td textAlign="center" borderWidth='1.5px' borderColor='#e6e6e6' >
                                                            {accessor === 'Recipient' && tData.length !== 0 ? (
                                                                <Button borderWidth="1px" borderColor="black" borderRadius={3} bgColor="#fff" h='6'
                                                                    onClick={(e) => handleImage(e, row)}
                                                                >{tData}</Button>
                                                            ) : (
                                                                <Text noOfLines={1}>{tData}</Text>
                                                            )}
                                                        </Td>
                                                        <Td className="columnResizer" bgColor='#fff'/>
                                                    </React.Fragment>
                                                    );
                                                })}
                                            </Tr>
                                        );
                                    })}
                                </Tbody>
                            </Table>
                            <Spacer />
                        </>
                    ) : (
                        <Flex>
                            <Text fontSize={25} color='#3b3b3b'>...keine Pakete gefunden!</Text>
                        </Flex>
                    )}
                    {totalPages > 1 ? (
                        <Flex flexDirection='column' alignItems='center' justifyContent='center' overflow='auto' minHeight='100px'>
                            <HStack justify="space-between" mt={4}>

                                <IconButton bg='#1DA1F2' borderRadius='5px' color='#fff' width='20px'
                                    onClick={() => updatePage(0)} isDisabled={page === 0}
                                    icon={<Icon as={FaAngleDoubleLeft} boxSize={25} />} />
                                <IconButton bg='#1DA1F2' borderRadius='5px' color='#fff' width='20px'
                                    onClick={handlePrev} isDisabled={page === 0}
                                    icon={<Icon as={FaAngleLeft} boxSize={25} />} />

                                <Text style={{ fontSize: 23 }}>Seite {page + 1} von {totalPages}</Text>

                                <IconButton bg='#1DA1F2' borderRadius='5px' color='#fff' width='20px'
                                    onClick={handleNext} isDisabled={page === totalPages - 1}
                                    icon={<Icon as={FaAngleRight} boxSize={25} />} />
                                <IconButton bg='#1DA1F2' borderRadius='5px' color='#fff' width='20px'
                                    onClick={() => updatePage(totalPages - 1)} isDisabled={page === totalPages - 1}
                                    icon={<Icon as={FaAngleDoubleRight} boxSize={25} />} />

                            </HStack>

                            <Slider
                                height='50px'
                                width='300px'
                                id='slider'
                                defaultValue={1}
                                min={1}
                                max={totalPages}
                                value={sliderValue}
                                color='#fff'
                                onChangeEnd={(val) => setPage(val - 1)}
                                onChange={(v) => setSliderValue(v)}
                                onMouseEnter={() => setShowTooltip(true)}
                                onMouseLeave={() => setShowTooltip(false)}
                            >
                                <SliderTrack>
                                    <SliderFilledTrack />
                                </SliderTrack>
                                <Tooltip
                                    hasArrow
                                    color='#fff'
                                    placement='top'
                                    isOpen={showTooltip}
                                    label={sliderValue}
                                >
                                    <SliderThumb>
                                        <Box height="20px" width="20px" borderWidth={3} borderColor="#1DA1F2" />
                                    </SliderThumb>
                                </Tooltip>
                            </Slider>
                        </Flex>
                    ) : (null)}

                </Flex>
            </Flex>
            <BaseModal isOpen={KundenIndex !== null} onClose={() => setKundenIndex(null)}
                style={{ display: 'flex', flex: 1, alignItems: 'center', padding: 3, flexDirection: 'column', maxWidth: '700px', minWidth: '700px', maxHeight: '450px', minHeight: '100px', padding: 10 }}
            >
                {KundenIndex !== null ? (
                    <Flex flexDirection='column' width='100%'>

                        <Flex>
                            <Text fontSize={17} fontWeight='bold' w='20%'>Name 1-4: </Text>
                            <Text fontSize={17} w='80%' >
                                {tableData[KundenIndex].Name1} | {tableData[KundenIndex].Name2} | {tableData[KundenIndex].Name3} | {tableData[KundenIndex].Name4}</Text>
                        </Flex>
                        <Flex>
                            <Text fontSize={17} fontWeight='bold' w='20%'>Adresse:</Text>
                            <Text fontSize={17} w='80%'>{tableData[KundenIndex].Strasse}, {tableData[KundenIndex].PLZ} {tableData[KundenIndex].Ort}</Text>
                        </Flex>
                        <Flex>
                            <Text fontSize={17} fontWeight='bold' w='20%'>Telefon:</Text>
                            <Text fontSize={17} w='80%'>{tableData[KundenIndex].Telefon}</Text>
                        </Flex>
                        <Flex>
                            <Text fontSize={17} fontWeight='bold' w='20%'>Konto:</Text>
                            <Text fontSize={17} w='80%'>{tableData[KundenIndex].Konto}</Text>
                        </Flex>

                    </Flex>
                ) : (null)}
            </BaseModal>

            <ConfirmModal
                isOpen={ConfirmOpen}
                close={() => setConfirmOpen(false)}
                modalText={CurentIndex !== null ? `Paket Nr.: ${tableData[CurentIndex]?.Paketnummer} wirklich löschen?` : ""}
                noButton="Abbrechen"
                yesButton="Löschen"
                yesFunc={() => deletePaketHandler()}
            />
            {ImageUri.length !== 0 ? (
                <ImageBox isOpen={ImageOpen} ImageCall={ImageCall} ImageDir={ImageDir} ImageUri={ImageUri} server={props.server}
                    curentReci={ImageRecipient}
                />
            ) : (null)}

            <HistoryBox isOpen={historyOpen} server={props.server} paketCall={HistoryCall}
                ImageDir={'tour_images/' //+ tableData[CurentIndex]?.LieferID +'/'
                }
                Image={CurentIndex !== null ? (tableData[CurentIndex]?.Image) : ('')}
                curentPaket={CurentIndex !== null ? (tableData[CurentIndex]?.Paketnummer) : ('')}
                History={history}
            />
            <BaseModal isOpen={loading} style={{ display: 'flex', flexDirection: 'column', height: '200px', minHeight: '200px', width: '30vw', alignItems: 'center', justifyContent: 'space-evenly', padding: 5 }} >
                <Text fontSize={20} >Pakete werden geladen...</Text>
                <Spinner thickness='6px' speed='1s' emptyColor='gray.200' color='blue.500' size='xl' />
            </BaseModal>
        </Flex >
    );
}